import React from 'react';
import SingleConfigFieldOptions from '../../_partials/WidgetEditControls/SingleConfigFieldOptions';
import ConfigPopover from '../../_partials/ConfigPopover';

export interface Props {
  moduleId: number;
  withManageLink?: boolean;
  onClose(): void;
}

export const WatchedDeviantsConfigPopover: React.FC<Props> = props => {
  return (
    <ConfigPopover onClose={props.onClose}>
      <SingleConfigFieldOptions
        moduleId={props.moduleId}
        paramName="sortBy"
        labels={{
          newest: 'common.sortOrder.newest',
          oldest: 'common.sortOrder.oldest',
        }}
        close={props.onClose}
      />
    </ConfigPopover>
  );
};
WatchedDeviantsConfigPopover.displayName = 'WatchedDeviantsConfigPopover';

export default WatchedDeviantsConfigPopover;
